module.exports = __webpack_public_path__ + "img/client.a822a36c.svg";